import { render, staticRenderFns } from "./SampleTypesGrid.vue?vue&type=template&id=0d59b745&scoped=true&"
import script from "./SampleTypesGrid.ts?vue&type=script&lang=ts&"
export * from "./SampleTypesGrid.ts?vue&type=script&lang=ts&"
import style0 from "./SampleTypesGrid.scss?vue&type=style&index=0&id=0d59b745&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d59b745",
  null
  
)

export default component.exports